export type SpaceValue = 'none' | 'sm' | 'md' | 'lg' | 'xl' | string | undefined;

function normalizeSpace(value?: SpaceValue): 'none' | 'sm' | 'md' | 'lg' | 'xl' | undefined {
  if (value == null) return undefined;
  const v = String(value).trim().toLowerCase();
  if (v === 'none') return 'none';
  if (v === 'sm' || v === 'small') return 'sm';
  if (v === 'md' || v === 'medium') return 'md';
  if (v === 'lg' || v === 'large') return 'lg';
  if (v === 'xl' || v === 'xlarge' || v === 'extra-large') return 'xl';
  return undefined;
}

export interface SectionSpaceConfig {
  spaceTop?: SpaceValue;
  spaceBottom?: SpaceValue;
  // legacy support
  marginTop?: SpaceValue;
  marginBottom?: SpaceValue;
}

/**
 * Returns class string like `mt-sm mb-lg` from CMS spaceTop/spaceBottom
 * Accepts both new (spaceTop/spaceBottom) and legacy (marginTop/marginBottom) fields.
 */
export function getSectionSpacingClasses(cfg: SectionSpaceConfig | any): string {
  const top = normalizeSpace(cfg?.spaceTop ?? cfg?.marginTop);
  const bottom = normalizeSpace(cfg?.spaceBottom ?? cfg?.marginBottom);
  return [top ? `mt-${top}` : '', bottom ? `mb-${bottom}` : ''].filter(Boolean).join(' ');
}


